<template>
    <div class="font-opensans vs-page">
      <div class="card shadow-sm vs-filter-card">
        <div class="vs-header">
          <div class="vs-header-title">
            <b-icon icon="people" font-scale="1.1"></b-icon>
            <span>Vista de Operadores</span>
          </div>
          <div class="vs-header-actions">
            <b-button v-if="!cargando" class="vs-action-btn" @click="nuevoOperador()">
              <b-icon icon="plus-circle"></b-icon> Nuevo
            </b-button>
            <b-spinner v-else class="text-center" variant="warning"></b-spinner>
          </div>
        </div>
        <div class="vs-filters">
          <b-input-group size="sm">
            <b-form-input v-model="filter" type="search" placeholder="Escribe para filtrar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''" class="vs-clear-btn">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="my-table" size="sm" pills align="center" class="mt-2">
          </b-pagination>
        </div>
      </div>
      <div class="card shadow-sm mt-3 vs-data-card">
        <b-table v-if="!cargando" hover small :items="operadores"
               :fields="fields" selectable responsive striped
                caption-top :filter="filter" select-mode="single" :per-page="perPage"
                :current-page="currentPage" label-sort-asc=""
                label-sort-desc="" label-sort-clear=""
                table-class="custom-table" thead-class="table-header"
                tbody-class="table-body" style="font-size:12px;">
          <template #table-caption><strong class="fcgreen">Operadores: {{ operadores.length }}</strong></template>
          <template #cell(edit)="data">
            <b-button size="sm" variant="outline-warning" @click="editarOperador(data.item)">Editar</b-button>
          </template>
          <template #cell(fecha_creacion)="data">
            <span v-html="formatearFecha(data.value,2)"></span>
          </template>
          <template #cell(fecha_modificacion)="data">
            <span v-html="formatearFecha(data.value,2)"></span>
          </template>
        </b-table>
        <b-spinner v-else class="text-center" variant="warning"></b-spinner>
      </div>
      <Modals ref="mod"></Modals>
    </div>
</template>
<script>
import Modals from '@/components/Modals.vue'
// import Operadores from '@/catalogos/Operadores.vue'
import {mapState,mapActions} from 'vuex'
import * as utils from "@/shared/util"

export default {
    data() {
        return {
            texto: 'Operadores',
            currentPage:1,
            perPage:15,
            fields:[{key: 'operador_id', label: 'operador_id', class:"d-none"},
                    {key: 'operador', label: 'Operador', sortable: true,class:'negritas'},
                    {key: 'nombre', label: 'Nombre', sortable: true},
                    {key: 'email', label: 'Email', sortable: true, class:'negritas'},
                    {key: 'clave', label: 'Clave', sortable: true, class:'d-none'},
                    {key: 'perfil', label: 'Perfil', sortable: true},
                    {key: 'estatus', label: 'Estatus', sortable: true, class:'negritas text-center'},
                    {key: 'imei', label: 'DeviceId', sortable: true},
                    {key: 'fecha_creacion', label: 'Creado', sortable: true,class:'text-center'},
                    {key: 'fecha_modificacion', label: 'Modificado', sortable: true,class:'text-center'},
                    {key: 'fecha_baja', label: 'Baja', sortable: true},
                    {key: 'edit', label: 'Acción', sortable: true},
                    // {key: 'DIFERENCIA', label: 'DIF', class:'negritas'},
                    ],
            operadores:[],
            filter:'',
            cargando:false,
        }
    },
    components: {
        Modals,
        // Operadores,
    },
    computed: {
        ...mapState(['operador','modal','menu']),
        rows() {
            return this.operadores.length
        },
     
    },
    created () {
       
        this.getoperadores()
    },
    methods: {
        ...mapActions(['actupdateMenu','actupdateModal']),
        showmodal(tittle,message){
            this.modal.tittle = tittle
            this.modal.message = message
            this.modal.type = 0
            this.actupdateModal(this.modal)
            // console.log("ahora contiene:  " + JSON.stringify(this.modal))
            this.$refs.mod.showmodal()
        },
        getoperadores() {
            this.cargando=true
            this.$store.dispatch("getOperadores").then((resp)=>{

                // console.warn("La respuesta de getoperadores: " + JSON.stringify(resp))
                if(resp.estatus == 1){
                    // this.operadores=resp.data
                    this.operadores=resp.operadores
                    this.cargando=false
                }else{
                    this.showmodal(this.texto, resp.message)
                    this.cargando=false
                }
            }).catch((err)=>{
                this.showmodal(this.texto, err)
                this.cargando=false
            })
        },
        nuevoOperador(){
           
           //console.warn("la ruta: " + this.$route.name)
            if (this.$route.name !== 'operadores') {
                this.$router.push({ name: 'operadores' });
            }
        },
        editarOperador(item){
           //console.log("edindo perador")
            this.$router.push({ name: 'operadores', params: item});
        },
        formatearFecha(fecha,formato=0) {
            //console.log("formateando fecha: " + fecha + "formato: " + formato)
            let fechaformateada=utils.getDateTime(fecha,formato)
           // console.log("formateando fecha: " + fechaformateada)
            return fechaformateada
        },
       
        imprimir(){
           
            utils.exportar(this.operadores,'Clientes distribidor')
           
         },
    },
}
</script>

<style scoped>
@import "@/assets/css/app.css";
</style>
